<script>
  import { createEventDispatcher } from 'svelte'
  import { fade } from 'svelte/transition'
  
  export let label, initialValue, step, unit = "", min = 0, max = null, digits, incrementLabel = "increase", decrementLabel = "decrease", showButtonLabels = true

  let value = initialValue
  
  let incrementDisabled 
  $: incrementDisabled = (max != null && value + step > max)

  let decrementDisabled
  $: decrementDisabled = (min != null && value - step < min)

  const dispatch = createEventDispatcher()

  let onIncrement = function(event){
    value += step
    dispatch('valueChanged', { value: value })
  }

  let onDecrement = function(event){
    value -= step
    dispatch('valueChanged', { value: value })
  }

  $: displayValue = parseFloat(value).toFixed(digits)

</script>

<div class="stepper" transition:fade="{{ duration: 150 }}">
  <div class="label-and-value">
    <h2 class="label">{label}</h2>
    <span class="value">{displayValue}{unit}</span>
  </div>
  <button type="button" class="btn-image btn-minus" disabled={decrementDisabled} on:click={onDecrement}>
    <span class="label small" class:show="{showButtonLabels}">{decrementLabel}</span>
  </button>
  <button type="button" class="btn-image btn-plus" disabled={incrementDisabled} on:click={onIncrement}>
    <span class="label small" class:show="{showButtonLabels}">{incrementLabel}</span>
  </button>
</div>

<style>

.stepper {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  background-color: #fff;
  border-radius: 37.5px;
  border: 2px solid black;
  -webkit-user-select: none;
  min-width: 185px;
  max-width: 270px;
}

.stepper > .label-and-value {
  position: absolute;
  height: 75px;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

h2 {
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  line-height: 1.15;
  text-transform: uppercase;
  margin: 0;
  margin-top: 0.3em;
}

.stepper .label {
  color: #555;
}

.stepper .value {
  font-family: 'Source Code Pro', monospace;
  font-size: 1.602em;
}

.stepper > button.btn-image {
  flex: 0 0 75px;
  margin-bottom: 0;
  border: 0 none;
  background-color: transparent;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
}

.stepper > button.btn-image:active {
  background-color: rgba(0, 0, 0, 0.2);
}

.stepper > button:disabled {
  opacity: 0.5
}

.stepper > button > span.label.show {
  display: block;
  opacity: 1;
  font-style: italic;
  font-weight: 600;
  position:relative;
  margin-bottom: -0.3em;
  text-transform: lowercase;
  color: #666;
}
</style>